import { AuthAction, AuthActionTypes, AuthState } from '../../types/auth';
import axios from 'axios';

const initialState: AuthState = {
  token: localStorage.getItem('token'),
  isAuthenticated: false,
  url: null,
  user: {
    _id: '',
    name: '',
    email: '',
    role: '',
  },
  score: 1,
  resetUser: null,
  resetTokenLoading: true,
  loading: false,
  userLoading: true,
  emailLoading: false,
};

export const authReducer = (
  state = initialState,
  action: AuthAction
): AuthState => {
  switch (action.type) {
    case AuthActionTypes.LOGIN_SUCCESS:
      const token = `Bearer ${action.payload.token}`;
      localStorage.setItem('token', token);
      axios.defaults.headers.common['Authorization'] = token;
      return {
        ...state,
        token,
        isAuthenticated: true,
        loading: false,
      };
    case AuthActionTypes.LOGIN_FAIL:
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      return {
        ...initialState,
        token: null,
        loading: false,
      };
    case AuthActionTypes.LOGOUT:
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      return {
        ...initialState,
        token: null,
      };
    case AuthActionTypes.ADD_LOADING:
      return {
        ...state,
        loading: true,
      };
    case AuthActionTypes.LOAD_USER:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        userLoading: false,
      };
    case AuthActionTypes.LOAD_USER_FAIL:
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      return {
        ...initialState,
        url: state.url,
        token: null,
        userLoading: false,
      };
    case AuthActionTypes.SET_URL:
      return {
        ...state,
        url: action.payload,
      };
    default:
      return state;
  }
};
